import script from "./BuyTraitModalOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyTraitModalOrder.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__